import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-under-development',
  templateUrl: './under-development.component.html',
  styleUrls: ['./under-development.component.scss']
})
export class UnderDevelopmentComponent {

  isDashboard: boolean = false
  constructor( private router: Router) { }

  ngOnInit() {
   
    if (this.router.url.includes('dashboard')) {
      this.isDashboard = true
    }
  }
}
